import { offset, flip, shift, size } from '@floating-ui/react';
import { resolvePositionArea, resolveMarginAxis } from '../utils/positioner/positioner.utils.js';

const PLACEMENTS = {
    top: { start: 'top-start', center: 'top', end: 'top-end' },
    bottom: { start: 'bottom-start', center: 'bottom', end: 'bottom-end' },
    left: { start: 'left-start', center: 'left', end: 'left-end' },
    right: { start: 'right-start', center: 'right', end: 'right-end' },
};
/** Convert an FPL Positioner area to the placement format used internally by Floating UI. */
function getPlacementFromPosition({ area }) {
    const resolvedArea = resolvePositionArea(area);
    const hasVerticalSide = resolvedArea.y === 'start' || resolvedArea.y === 'end';
    const hasHorizontalSide = resolvedArea.x === 'start' || resolvedArea.x === 'end';
    if (hasVerticalSide || !hasHorizontalSide) {
        const side = resolvedArea.y === 'start' || resolvedArea.y === 'span-start' ? 'top' : 'bottom';
        const alignment = resolvedArea.x === 'span-end' ? 'start' : resolvedArea.x === 'span-start' ? 'end' : 'center';
        return PLACEMENTS[side][alignment];
    }
    const side = resolvedArea.x === 'start' ? 'left' : 'right';
    const alignment = resolvedArea.y === 'span-end' ? 'start' : resolvedArea.y === 'span-start' ? 'end' : 'center';
    return PLACEMENTS[side][alignment];
}
function createPositionMiddleware({ position, padding, }) {
    const placement = getPlacementFromPosition(position);
    const margin = resolveMarginAxis(position.margin);
    const isVertical = placement.startsWith('top') || placement.startsWith('bottom');
    return [
        offset({
            mainAxis: isVertical ? margin.y : margin.x,
            alignmentAxis: isVertical ? margin.x : margin.y,
        }),
        flip({ padding }),
        shift({ padding }),
        size({
            apply({ rects, availableWidth, availableHeight, elements }) {
                Object.assign(elements.floating.style, {
                    minWidth: `${rects.reference.width}px`,
                    maxWidth: `${availableWidth}px`,
                    maxHeight: `${availableHeight}px`,
                    display: 'flex',
                    flexDirection: 'column',
                });
            },
            padding,
        }),
    ];
}

export { createPositionMiddleware, getPlacementFromPosition };
//# sourceMappingURL=select-primitive.positioning.js.map
